import { getNavMeshPositionsAndIndices, type NavMesh } from '@recast-navigation/core';
import { BufferAttribute, BufferGeometry, type Material, Mesh, MeshBasicMaterial } from 'three';

export type NavMeshHelperParams = {
  material?: Material;
  flags?: number;
};

export class NavMeshHelper extends Mesh {
  navMesh: NavMesh;

  /**
   * Flags for the nav mesh.
   * @default 0
   */
  flags: number;

  constructor(navMesh: NavMesh, params?: NavMeshHelperParams) {
    super(
      new BufferGeometry(),
      params?.material ??
        new MeshBasicMaterial({
          color: 'orange',
          transparent: true,
          opacity: 0.7,
          depthWrite: false,
        }),
    );

    this.navMesh = navMesh;

    this.flags = params?.flags ?? 0;

    this.update();
  }

  /**
   * Update the three debug nav mesh.
   *
   * This should be called after updating the nav mesh.
   */
  update() {
    const [positions, indices] = getNavMeshPositionsAndIndices(
      this.navMesh,
      this.flags || undefined,
    );

    this.geometry.setAttribute('position', new BufferAttribute(Float32Array.from(positions), 3));
    this.geometry.setIndex(new BufferAttribute(Uint32Array.from(indices), 1));
    this.geometry.computeVertexNormals();
  }

  copy(target: NavMeshHelper): this {
    target.navMesh = this.navMesh;
    target.flags = this.flags;
    super.copy(target);
    return this;
  }
}
